module.exports = __webpack_public_path__ + "img/chapter-2-thumb.afac93fc.jpg";